import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@app/shared';
import { AuthGuard, ROLES } from '@app/core/auth';

import { ReportListComponent } from '@app/features/reports';
import {
  PanelListComponent,
  PanelManagerComponent,
  MyPanelsComponent,
  PanelDetailComponent,
  panelResolver,
} from '@app/features/panels';
import { UserListComponent } from '@app/features/users';
import {
  QueryManagerComponent,
  queryResolver,
} from '@app/features/query-build';
import {
  EntityListComponent,
  EntityDetailComponent,
  entityResolver,
} from './features/entities';
import { ApplicationListComponent } from '@app/features/applications';
import { ExportListComponent } from './features/exports';
import { QueryBasicComponent } from '@app/features/query-basic';
import { ProfileListComponent } from './features/profiles';
import { QueryResultsComponent } from './features/query-basic/query-results/query-results.component';
import { PatientRequestsRoutingModule } from './features/patient-requests';
import { UserDetailComponent } from './features/users/user-detail/user-detail.component';
import { WxrlRoutingModule } from './features/wxrl/wxrl-routing.module';
import { CommentListComponent } from './features/panels/components/comment-list/comment-list.component';
import { DashboardComponent } from './features/dashboard';
import { TranslationListComponent } from './features/translations';
import { LogsViewComponent } from './features/logs/logs-view.component';

const securedRoute: Route = {
  canActivate: [AuthGuard],
};

const adminRoute: Route = {
  ...securedRoute,
  data: {
    roles: [ROLES.Admin],
  },
};

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: DashboardComponent
  },
  {
    path: 'reports',
    component: ReportListComponent,
    ...adminRoute,
  },
  {
    path: 'panels',
    component: PanelListComponent,
    ...adminRoute,
  },
  {
    path: 'multicast/comments',
    component: CommentListComponent,
    ...securedRoute,
  },
  {
    path: 'exports',
    component: ExportListComponent,
    ...securedRoute,
  },
  {
    path: 'my-panels',
    component: MyPanelsComponent,
    ...securedRoute,
  },
  {
    path: 'my-panels/:id',
    component: PanelDetailComponent,
    resolve: { panel: panelResolver },
    ...securedRoute,
  },
  {
    path: 'panels/:id',
    component: PanelManagerComponent,
    resolve: { panel: panelResolver },
    ...adminRoute,
  },
  {
    path: 'profiles',
    component: ProfileListComponent,
    ...adminRoute,
  },
  {
    path: 'users',
    // component: UserListComponent,
    ...adminRoute,
    children: [
      {
        path: '',
        component: UserListComponent,
      },
      {
        path: 'new',
        component: UserDetailComponent,
        data: { isNew: true },
        ...adminRoute,
      },
      {
        path: ':id',
        component: UserDetailComponent,
        ...adminRoute,
      },
    ],
  },

  {
    path: 'query',
    component: QueryManagerComponent,
    ...securedRoute,
  },
  {
    path: 'query/new',
    component: QueryBasicComponent,
    ...securedRoute,
  },
  {
    path: 'query/results/:id',
    component: QueryResultsComponent,
    ...securedRoute,
  },
  {
    path: 'query/:id',
    component: QueryBasicComponent,
    resolve: { query: queryResolver },
    ...securedRoute,
  },
  {
    path: 'entities',
    component: EntityListComponent,
    ...adminRoute,
  },
  {
    path: 'entities/:id',
    component: EntityDetailComponent,
    resolve: { entity: entityResolver },
    ...adminRoute,
  },
  {
    path: 'applications',
    component: ApplicationListComponent,
    ...adminRoute,
  },
  {
    path: 'translations',
    component: TranslationListComponent,
    ...adminRoute,
  },
  {
    path: 'logs',
    component: LogsViewComponent,
    ...adminRoute,
  },
];

@NgModule({
  imports: [
    SharedModule,
    PatientRequestsRoutingModule,
    WxrlRoutingModule,
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
